module.exports = "<div class=\"avatar-container\" ng-class=\"$ctrl.getContainerCss()\">\n  <img ng-if=\"$ctrl.source\" ng-src=\"{{$ctrl.source}}\" alt=\"{{'GLOBALS.AVATAR_TITLE' | translate}}\"/>\n  <div ng-if=\"!$ctrl.source\" class=\"initials-container\">\n    <span>{{$ctrl.nameFirstLetter}}</span>\n    <span>{{$ctrl.lastNameFirstLetter}}</span>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/avatar/avatar.html
// module id = 700
// module chunks = 0